import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

export const deviceSession = {
  get: () => localStorage.getItem("nasdeal_primary_device"),
  set: (token) => localStorage.setItem("nasdeal_primary_device", token),
  clear: () => localStorage.removeItem("nasdeal_primary_device"),
};

export const saveAuth = (data) => {
  if (data.token) accessSession.set(data.token);
  if (data.device_refresh_token) deviceSession.set(data.device_refresh_token);
};

export const accessSession = {
  get: () => sessionStorage.getItem("nasdeal_access"),
  set: (token) => sessionStorage.setItem("nasdeal_access", token),
  clear: () => sessionStorage.removeItem("nasdeal_access"),
};

api.interceptors.request.use((config) => {
  const token = accessSession.get();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    config.withCredentials = false;
  }
  if (config.url === "/auth/refresh" || config.url === "/auth/logout") {
    const refresh = deviceSession.get();
    if (refresh) config.headers["X-NasDeal-Device-Refresh"] = refresh;
  }
  return config;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    if (error.response?.status === 401 && !cfg._retry && cfg.url !== "/auth/refresh" && cfg.url !== "/auth/login" && deviceSession.get()) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        const refreshed = await refreshing;
        saveAuth(refreshed.data);
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
        deviceSession.clear();
        accessSession.clear();
      }
    }
    return Promise.reject(error);
  }
);

export const imgUrl = (u) => (!u ? "/logo-nasdeal.jpg" : u.startsWith("/api/") ? `${BACKEND}${u}` : u);

export const formatPrice = (n) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(n || 0);

export const formatDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" }) : "";

export function formatError(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export const INSTAGRAM_URL = "https://www.instagram.com/nasdeal_/";
export const INSTAGRAM_HANDLE = "@NasDeal_";
export const WHATSAPP_URL = "https://wa.me/33667189172";
export const WHATSAPP_NUMBER = "06 67 18 91 72";

export const ORDER_STATUS = {
  en_attente_paiement: "En attente de paiement",
  payee: "Confirmée",
  en_preparation: "En préparation",
  expediee: "Expédiée",
  prete_retrait: "Prête au retrait",
  livree: "Livrée",
  annulee: "Annulée",
  remboursee: "Remboursée",
};
